import { render } from "./AppSubBanner.vue?vue&type=template&id=174130c9"
const script = {}

import "./AppSubBanner.vue?vue&type=style&index=0&id=174130c9&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__